module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--logout-d2b4623aa2a796935095857cedc2cb8d.png";